<template>
    <div>
        <div id="update_provider_services">
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#inquiry_services_tab"
                           @click="gotoTab(1)">
                            {{ $t('application.services.inquiry_services') }}
                        </a>
                    </li>
<!--                    <li class="nav-item">-->
<!--                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#authentication_services_tab"-->
<!--                           @click="gotoTab(2)">-->
<!--                            {{ $t('application.services.authentication_services') }}-->
<!--                        </a>-->
<!--                    </li>-->
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#financial_services_tab"
                           @click="gotoTab(3)">
                            {{ $t('application.services.financial_services') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
            <form id="update_service_wages_form">
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
                        <kt-col v-if="serviceProviders" lg="12" md="12" sm="12">
                            <application-services :all_services="inquiryServices"
                                                  :service_providers="serviceProviders"
                                                  :service_wages="getServiceWages('inquiryServices')"
                            ></application-services>
                        </kt-col>
                    </div>
<!--                    <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">-->
<!--                        <kt-col v-if="serviceProviders" lg="12" md="12" sm="12">-->
<!--                            <application-services :all_services="authenticationServices"-->
<!--                                                  :service_providers="serviceProviders"-->
<!--                                                  :service_wages="getServiceWages('authenticationServices')"-->
<!--                            ></application-services>-->
<!--                        </kt-col>-->
<!--                    </div>-->
                    <div :class="['tab-pane', currentTab === 3 ? 'active' : '']">
                        <kt-col v-if="serviceProviders" lg="12" md="12" sm="12">
                            <financial-services :all_services="financialServices"
                                                :service_providers="serviceProviders"
                                                :service_wages="getServiceWages('financialServices')"
                            ></financial-services>
                        </kt-col>
                    </div>
                </div>
            </form>
            <kt-row>
                <kt-col v-if="serviceWages" class="col-lg-3  col-sm-6" style="text-align: right; margin-top: 35px;padding-right: 30px">
                    <kt-form-group>
                        <div class="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="dont_use_dedicated_setting"
                                name="dont_use_dedicated_setting"
                                v-model="serviceWages.dont_use_dedicated_setting"
                            >
                            <label class="custom-control-label" for="dont_use_dedicated_setting">{{
                                    $t('application.dont_use_dedicated_setting')
                                }}</label>
                        </div>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-9  col-sm-6" style="text-align: left">
                    <kt-form-action class="mt-4">
                        <kt-button

                            class="m-2 btn-wide"
                            size="md"
                            variant="success"
                            type="button"
                            v-bind:wide="true"
                            id="update_service_wages_btn"
                            @click="changeServiceWage()"
                        >
                            {{ $t('btn.edit') }}
                        </kt-button>
                    </kt-form-action>
                </kt-col>
            </kt-row>
        </div>

    </div>
</template>

<script>

import $ from 'jquery'
import toastr from "toastr";
import {openBankingService} from "@/common/api.service";
import {
    services,
    providerType,
    providerTypeStr,
    financialServices,
    authenticationServices,
    inquiryServices,
    changeableWageServices
} from '@/constants/openBanking';
import applicationServices from './application-services';
import FinancialServices from './financial-services';
import {i18n} from '@/plugins/i18n';
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util';

export default {
    components: {
        'application-services': applicationServices,
        'financial-services': FinancialServices,
    },
    mounted() {
        this.fetchServiceWages();
    },
    updated() {
        if (document.getElementById('signature_holder_hr_tag0'))
            document.getElementById('signature_holder_hr_tag0').style.display = 'none'
    },
    data() {
        return {
            serviceWages: null,
            serviceProviders: null,
            'hashid': this.$route.params.hashid,
            financialServices,
            // authenticationServices,
            // inquiryServices,
            providerType,
            providerTypeStr,
            services,
            currentTab: 1,
            changeableWageServices
        }
    },
    computed: {
      inquiryServices() {
        return {...inquiryServices,...authenticationServices};
      },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        changeServiceWage() {
            let form = $('#update_service_wages_form')
            let btn = $('#update_service_wages_btn')
            if (!this.serviceWages.dont_use_dedicated_setting) {
                let rules = {}
                let auth_inquiry_services = {...this.inquiryServices, ...this.authenticationServices}
                Object.values(auth_inquiry_services).forEach(value => {
                    Object.values(this.getProviders(value)).forEach(provider => {
                        rules[value + '_company_wage'] = {required: true};
                        rules[value + '_provider_wage'] = {required: true};
                    })
                })
                Object.values(this.financialServices).forEach(service => {
                    Object.values(this.getProviders(service)).forEach(bank => {
                        rules[service + '_' + bank + '_provider'] = {required: true};
                        rules[service + '_' + bank + '_company_wage'] = {required: true};
                        rules[service + '_' + bank + '_provider_wage'] = {required: true};
                        if (Object.values(this.changeableWageServices).includes(service)) {
                            rules[service + '_' + bank + '_company_wage_type'] = {required: true}
                            rules[service + '_' + bank + '_provider_wage_type'] = {required: true}
                            if (this.serviceWages[service][bank].company_wage_type == 2) {//percentage
                                rules[service + '_' + bank + '_company_min_wage'] = {required: true};
                                rules[service + '_' + bank + '_company_max_wage'] = {required: true};
                            }
                            if (this.serviceWages[service][bank].provider_wage_type == 2) {//percentage
                                rules[service + '_' + bank + '_provider_min_wage'] = {required: true};
                                rules[service + '_' + bank + '_provider_max_wage'] = {required: true};
                            }
                        }
                    })
                })

                form.validate({
                    rules: rules,
                    invalidHandler: function (form, validator) {
                        console.log('Validation errors:');
                        $.each(validator.errorList, function (index, error) {
                            console.log(error.message + ' for element: ' + error.element.name);
                        });

                        console.log('Validator object:', validator);
                    },
                });

                if (!form.valid()) {
                    return this.toastr.error(i18n.t('open_banking.message.fill_all'))
                }
            }

            KTApp.progress(btn)
            openBankingService.adminUpdateServiceWages(this.$route.params.hashid, this.serviceWages).then(response => {
                this.showMsg(form, 'success', response.data.message);
                if (this.serviceWages.dont_use_dedicated_setting) {
                    this.fetchServiceWages()
                }
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTUtil.scrollTop();
                KTApp.unprogress(btn)
            })
        },
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
        },
        getProviders(service) {
            return Object.keys(this.serviceProviders[service])
        },
        fetchServiceWages() {
            openBankingService.adminGetApplicationServiceWages(this.hashid).then(response => {
                this.serviceWages = response.data.data.data;
                this.serviceProviders = response.data.data.service_providers;
            });
            this.afterDispatch()
        },
        getServiceWages(service_category) {
            let resp = {};
            for (let key in this.serviceWages) {
                if (Object.values(this[service_category]).includes(key)) {
                    resp[key] = this.serviceWages[key]
                }
            }
            return resp;
        },
        afterDispatch() {
            $('.kt-selectpicker-app-details').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    }
}
</script>